import { useEffect, useState } from "react";
import { User } from "../types";
import { useQuery } from "./useQuery";
import { useStores } from "./useStores";
import { useSharepointSupervisionedUsers } from "./sharepoint.hooks";

export const useActiveUser = () => {
  const { session } = useStores();
  const params = useQuery();

  const [activeUserId, setActiveUserId] = useState<User["Id"] | null>(null);

  useEffect(() => {
    if (params.get("user")) {
      setActiveUserId(Number(params.get("user")));
    } else if (session.user) {
      setActiveUserId(session.user.Id);
    }
  }, [params, session.user]);

  // Un id non positivo (es. segnaposto `-1`) viene normalizzato a `null`, così
  // le guardie `enabled: !!userId` degli hook non lasciano partire chiamate API
  // con `userId=-1`.
  return activeUserId && activeUserId > 0 ? activeUserId : null;
};

export const useActiveUserData = () => {
  const activeUserId = useActiveUser();
  const { data: supervisionedUsers = [] } = useSharepointSupervisionedUsers();

  const [activeUserData, setActiveUserData] = useState<User | null>(null);

  useEffect(() => {
    if (activeUserId) {
      const activeUser = supervisionedUsers.find(
        (user) => user.Id === activeUserId
      );
      setActiveUserData(activeUser || null);
    }
  }, [activeUserId, supervisionedUsers]);

  return activeUserData;
};
